import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StepStatus {
  isComplete: boolean;
  hasError: boolean;
}

export type FAQPreference = 'file-upload' | 'question-answer' | '';

interface GeneralSupportState {
  faqSetup: {
    data: {
      preference: FAQPreference;
      faqList: {
        question: string;
        answer: string;
      }[];
      uploadedFile?: string;
    };
    status: StepStatus;
  };
  errors: Record<string, string>;
  isProfileComplete: boolean;
}

const initialState: GeneralSupportState = {
  faqSetup: {
    data: {
      preference: '',
      faqList: [],
    },
    status: { isComplete: false, hasError: false },
  },
  errors: {},
  isProfileComplete: false,
};

const generalSupportSlice = createSlice({
  name: 'generalSupport',
  initialState,
  reducers: {
    updateFAQSetup: (
      state,
      action: PayloadAction<Partial<typeof initialState.faqSetup.data>>
    ) => {
      state.faqSetup.data = {
        ...state.faqSetup.data,
        ...action.payload,
      };
    },
    setStepStatus: (
      state,
      action: PayloadAction<{
        step: keyof Pick<GeneralSupportState, 'faqSetup'>;
        status: StepStatus;
      }>
    ) => {
      const { step, status } = action.payload;
      state[step].status = status;
    },
    setErrors: (state, action: PayloadAction<Record<string, string>>) => {
      state.errors = action.payload;
    },
    clearErrors: state => {
      state.errors = {};
    },
    setProfileComplete: (state, action: PayloadAction<boolean>) => {
      state.isProfileComplete = action.payload;
    },
    clearAllState: state => {
      Object.assign(state, initialState);
    },
  },
});

export const {
  updateFAQSetup,
  setStepStatus,
  setErrors,
  clearErrors,
  setProfileComplete,
  clearAllState,
} = generalSupportSlice.actions;

export default generalSupportSlice.reducer;
